import { useTranslation } from 'react-i18next';

type ComingSoonCtaProps = {
  size?: 'md' | 'lg';
  className?: string;
};

export default function ComingSoonCta({ size = 'md', className = '' }: ComingSoonCtaProps) {
  const { t } = useTranslation();
  const sizeClasses = size === 'lg' ? 'px-10 py-4 text-base' : 'px-8 py-3.5 text-sm';

  return (
    <span
      className={`inline-flex items-center gap-3 rounded-full bg-sand/50 border border-sand/70 font-sans font-semibold text-[#8B6F5C] cursor-not-allowed whitespace-nowrap ${sizeClasses} ${className}`}
    >
      <i className="ri-time-line" />
      {t('common.proximamente')}
    </span>
  );
}